import { useRef } from 'react';
import { useField } from 'formik';
import { ticketFieldLabelClass } from '../core/_utils';
import TicketFieldHint from './TicketFieldHint';

type Props = {
  name: string;
  label: string;
  required?: boolean;
  help?: string;
};

const TicketUploadField = ({ name, label, required = false, help }: Props) => {
  const [field, meta, helpers] = useField<string>(name);
  const { setValue } = helpers;
  const labelClass = ticketFieldLabelClass(required);
  const id = `ticket-${name}`;
  const error = meta.touched ? meta.error : undefined;
  const fileName = field.value;
  const inputRef = useRef<HTMLInputElement>(null);

  const chooseFile = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) void setValue(file.name);
  };

  const pickFile = () => inputRef.current?.click();

  const removeFile = () => setValue('');

  return (
    <div className="mb-5">
      <label className={labelClass} htmlFor={id}>
        {label}
      </label>
      <div className="d-flex align-items-center gap-3">
        <input
          key={fileName}
          ref={inputRef}
          accept="image/*"
          className="d-none"
          id={id}
          type="file"
          onChange={chooseFile}
        />
        {fileName ? (
          <span className="d-inline-flex align-items-center gap-2 text-gray-800 fs-7">
            <i className="bi bi-image text-gray-600" />
            {fileName}
            <button
              aria-label={`Remover ${label}`}
              className="btn btn-icon btn-sm h-auto w-auto p-0 ms-1"
              type="button"
              onClick={removeFile}
            >
              <i className="bi bi-x fs-4 text-gray-600" />
            </button>
          </span>
        ) : (
          <button className="btn btn-sm btn-light-primary" type="button" onClick={pickFile}>
            <i className="bi bi-camera" /> Enviar foto
          </button>
        )}
      </div>
      <TicketFieldHint error={error} help={help} />
    </div>
  );
};

export default TicketUploadField;
